/**
 * EZTree 枚舉常量（從 @dgreenheck/ez-tree 移植）
 *
 * 僅保留幾何生成所需的枚舉，移除了紋理類型
 */

/** 樹皮類型 */
export const BarkType = {
  Birch: 'birch',
  Oak: 'oak',
  Pine: 'pine',
  Willow: 'willow',
} as const
export type BarkTypeValue = typeof BarkType[keyof typeof BarkType]

/** Billboard 模式 */
export const Billboard = {
  Single: 'single',
  Double: 'double',
} as const
export type BillboardValue = typeof Billboard[keyof typeof Billboard]

/** 樹葉類型 */
export const LeafType = {
  Ash: 'ash',
  Aspen: 'aspen',
  Pine: 'pine',
  Oak: 'oak',
} as const
export type LeafTypeValue = typeof LeafType[keyof typeof LeafType]

/** 樹木類型 */
export const TreeType = {
  Deciduous: 'deciduous',
  Evergreen: 'evergreen',
} as const
export type TreeTypeValue = typeof TreeType[keyof typeof TreeType]
